import React, { useState } from 'react';
import '../styles/Convocatorias.css';

/*Componentes Convocatorias*/
import CAS_I_2025 from './Convocatorias/CASI2025';
import CAS_II_2025 from './Convocatorias/CASII2025';
import CAS_III_2025 from './Convocatorias/CASIII2025';
import CAS_IV_2025 from './Convocatorias/CASIV2025';
import CAS_V_2025 from './Convocatorias/CASV2025';
import CAS_VI_2025 from './Convocatorias/CASVI2025';
import CAS_I_2023 from './Convocatorias/CASI2023';
import CAS_II_2023 from './Convocatorias/CASII2023';
import CAS_III_2023 from './Convocatorias/CASIII2023';
import CAS_IV_2023 from './Convocatorias/CASIV2023';
import CAS_V_2023 from './Convocatorias/CASV2023';
import CAS_VI_2023 from './Convocatorias/CASVI2023';
import CAS_VII_2023 from './Convocatorias/CASVII2023';
import CAS_I_2024 from './Convocatorias/CASI2024';
import CAS_II_2024 from './Convocatorias/CASII2024';
import CAS_III_2024 from './Convocatorias/CASIII2024';
import CAS_IV_2024 from './Convocatorias/CASIV2024';
import CAS_V_2024 from './Convocatorias/CASV2024';


function Convocatorias(){

  const [casActivo, setCasActivo] = useState('CAS VI 2025');
  
  const casData = {
    'CAS VI 2025': CAS_VI_2025,
    'CAS V 2025': CAS_V_2025,
    'CAS IV 2025': CAS_IV_2025,
    'CAS III 2025': CAS_III_2025,
    'CAS II 2025': CAS_II_2025,
    'CAS I 2025': CAS_I_2025,
  };

  return (
    <div className='cas-wrapper'>
      <div className='cas-sidebar'>
        {Object.keys(casData).map((cas) => (
          <button
            key={cas}
            className={`cas-btn ${casActivo === cas ? 'activo' : ''}`}
            onClick={() => setCasActivo(cas)}
          >
            {cas}
          </button>
        ))}
      </div>
      <div className='cas-content'>
        {casData[casActivo] && React.createElement(casData[casActivo])}
      </div>
    </div>
  );
};

export default Convocatorias;


